import {
  ChangeDetectionStrategy,
  Component, DoCheck,
  EventEmitter,
  Inject,
  Input, OnChanges, OnInit,
  Output, SimpleChanges, ViewChild
} from "@angular/core";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import * as _ from "lodash";
import {NgxPermissionsService} from "ngx-permissions";
import {OrderModel} from "../../../models/order.model";

require('./oms-orders-table.scss');
@Component({
  standalone: false,
  selector: 'app-oms-orders-table',
  templateUrl: './oms-orders-table.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OmsOrdersTableComponent implements OnInit, OnChanges, DoCheck {

  @Input() orders: OrderModel[];
  @Input() selectedIds: string[];
  @Input() excludeMode: boolean;
  @Input() columns: any;
  @Input() dynamicColumns: any;
  @Input() packageDynamicColumns: any;
  @Input() isScrollable: boolean;
  @Input() isLoading: boolean;
  @Input() isInitialized: boolean;
  @Input() ordersCount: number;
  @Input() sortType: any;
  @Input() canRecoverOrders: boolean;

  @Output() onSelectOrdersChanged = new EventEmitter<any>();
  @Output() fetchNextEvent = new EventEmitter<null>();
  @Output() onSortTypeChange = new EventEmitter<string>();
  @Output() onFilterByType = new EventEmitter<{ type: string, value: string }>();
  @Output() onSendToDispatch = new EventEmitter<string>();
  @Output() onAddNote = new EventEmitter<string>();
  @Output() onSetOrderOnHold = new EventEmitter<string>();
  @Output() onResumeOrder = new EventEmitter<string>();
  @Output() onManuallyCompleteOrder = new EventEmitter<string>();
  @Output() onEdit = new EventEmitter<string>();
  @Output() onDuplicate = new EventEmitter<string>();
  @Output() onPrintBillOfLading = new EventEmitter<string>();
  @Output() onDownloadBillOfLading = new EventEmitter<string>();
  @Output() onSendSchedulingSms = new EventEmitter<string>();
  @Output() onSendSchedulingWhatsapp = new EventEmitter<string>();
  @Output() onViewSchedulingLink = new EventEmitter<string>();
  @Output() onRecover = new EventEmitter<string>();
  @Output() onCancelOrder = new EventEmitter<string>();

  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  public asceDescIconsMap: any;
  public selectedKeys = undefined;
  public expandedKeys = {};
  public enabledDynamicColumns: any;
  public enabledPackageDynamicColumns: any;
  public readonly skeletonRows: undefined[] = Array.from({length: 10});


  constructor(@Inject(NgxPermissionsService) private permissionsService: NgxPermissionsService) {
  }

  ngOnInit() {

    this.asceDescIconsMap = {
      asc: 'sort-asc',
      desc: 'sort-desc',
      undefined: 'sort'
    };

    this.initSelectedKeysMap();
    this.setEnabledColumns();
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this.initSelectedKeysMap();
    }

    if (changes.dynamicColumns && !changes.dynamicColumns.isFirstChange() ||
      changes.packageDynamicColumns && !changes.packageDynamicColumns.isFirstChange()) {
      this.setEnabledColumns();
    }
  }

  ngAfterViewInit(): void {
    const div1 = document.getElementById('header');
    const div2 = document.querySelectorAll('.cdk-virtual-scroll-viewport')[0];


    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    })
  }

  ngDoCheck() {
    this.cdkVirtualScrollViewport?.checkViewportSize();
  }

  getNextBatch() {
    if (this.cdkVirtualScrollViewport.measureScrollOffset('bottom') < 50) {
      this.fetchNextEvent.emit();
    }
  }

  onToggleSelectAll() {
    this.onSelectOrdersChanged.emit({
      selectedIds: [],
      excludeMode: !this.excludeMode
    });
  }

  onToggleOrderSelect(order) {
    this.selectedKeys[order.id] = !this.selectedKeys[order.id];
    this.onSelectOrdersChanged.emit({
      selectedIds: _.keys(_.pickBy(this.selectedKeys, _.identity)),
      excludeMode: this.excludeMode
    });
  }

  onSortChange(name: string) {
    this.onSortTypeChange.emit(name);
  }

  private initSelectedKeysMap() {
    this.selectedKeys = {};
    _.forEach(this.selectedIds, (selectedId) => {
      this.selectedKeys[selectedId] = true;
    });
  }

  private setEnabledColumns() {
    this.enabledDynamicColumns = this.dynamicColumns?.filter((c) => c.enabled) || [];
    this.enabledPackageDynamicColumns = this.packageDynamicColumns?.filter((c) => c.enabled) || [];
  }

}
